export const HOME_QUERY = `*[_type == "project"]{
    index,
    isActive,
    packLabel,
    releasedAt,
    slug,
    title,
}[0...50]`;